import {Header} from "semantic-ui-react";
import {VerticalTimeline} from "react-vertical-timeline-component";
import {Theatre} from "./Theatre";
import React from "react";

const VolunteerTimeline = React.memo(({volunteerExperience, filter, range}) => {
    const experience = volunteerExperience
        .filter(({companies}) => companies.some(item2 => filter.includes(item2)))
        .filter(({season}) => {
            const dates = season.map(({dates}) => dates).flat()
            const today = new Date(), mostRecentExperience = new Date(dates[dates.length - 1]);
            const timeDifference = Math.abs(mostRecentExperience.getTime() - today.getTime());
            const days = Math.ceil(timeDifference / (1000 * 3600 * 24))
            return range ? days < range : true
        })

    if (experience.length === 0) {
        return <Header as='h3'>No shows</Header>
    }

    return <VerticalTimeline
        layout={'1-column-left'}
        lineColor={'rgba(34,36,38,.1)'}
    >
        {
            experience.map(companyData => (
                <Theatre
                    key={companyData.season.map(({dates}) => dates).join()}
                    data={companyData}
                />
            ))}
    </VerticalTimeline>;
});

export { VolunteerTimeline }